module.exports = __webpack_public_path__ + "media/images/logo-47186cfe5fd8e8bc6dffa00f6b10782a.svg";